export const sdbThemeFonts = {
    sourceSansPro: {
        family: "SourceSansPro-Regular",
        color: "#023850",
        size: 12,
        weight: {
            light: 300,
            normal: 400,
            bold: 600,
        },
    },
};
export default sdbThemeFonts;
